 const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-10 px-6 md:px-24 text-gray-700">
      <h1 className="text-2xl md:text-4xl font-bold mb-6 text-blue-600">
        Privacy Policy
      </h1>

      <p className="mb-4">
        At <strong>TGM Nursing Institute</strong>, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you interact with our website or services.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">1. Information We Collect</h2>
      <p className="mb-4 text-xs">
        We may collect personal information such as your name, email address, phone number, and educational details when you fill out admission forms, contact us, or subscribe to our newsletter.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">2. How We Use Your Information</h2>
      <p className="mb-4 text-xs">
        Your information is used to process admissions, respond to inquiries, send important updates, provide educational services, and improve our website and offerings.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">3. Data Protection</h2>
      <p className="mb-4 text-xs">
        We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">4. Sharing of Information</h2>
      <p className="mb-4 text-xs">
        We do not sell or trade your personal information. Information may be shared with authorized staff or government authorities for official purposes, as required by law.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">5. Cookies & Analytics</h2>
      <p className="mb-4 text-xs">
        Our website may use cookies and analytics tools to enhance user experience and monitor website traffic. You can control cookies via your browser settings.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">6. Your Rights</h2>
      <p className="mb-4 text-xs">
        You have the right to access, update, or delete your personal information. Contact us at <strong>tgmnursing2019@gmail.com</strong> for any requests.
      </p>

      <h2 className="text-xs font-semibold mt-6 mb-2 text-purple-600">7. Changes to This Policy</h2>
      <p className="mb-4 text-xs">
        We may update this Privacy Policy periodically. All changes will be posted on this page with the date of revision.
      </p>

      <p className="mt-6 text-gray-600">
        © 2026 TGM Nursing Institute. All rights reserved.
      </p>
    </div>
  );
};

export default PrivacyPolicy;